let currentMode = 'default';
let currentData = null;
const modeManagers = {
  default: require('./editor-modes/default'),
  template: require('./editor-modes/template'),
  sticker: require('./editor-modes/sticker'),
  banner: require('./editor-modes/banner'),
  placeholder: require('./editor-modes/placeholder'),
  logo: require('./editor-modes/logo'),
  restrict: require('./editor-modes/restrict'),
  brand_template: require('./editor-modes/brand-template')
};

const availableModeManagers = {};
_.each(modeManagers, function (ModeManager, mode) {
  availableModeManagers[mode] = new ModeManager();
});

module.exports = {
  setMode: function (mode, data) {
    if (availableModeManagers[mode]) {
      availableModeManagers[currentMode].disable();

      currentMode = mode;
      currentData = data;

      availableModeManagers[mode].enable(data);
    }
  },

  getMode: function () { return currentMode; },
  getData: function () { return currentData; },
  isMode: function (mode) { return currentMode === mode; }
};
